/** Compliance editor — TCVN/MPS cert status, import license. */
import { useState } from 'react';

const STATUS_OPTIONS = ['verified', 'pending', 'not_required', 'unknown'];

export default function ComplianceEditor({ compliance, onChange }) {
    const [tab, setTab] = useState('en');
    const c = compliance || {};

    const update = (field, value) => {
        onChange({ ...c, [field]: value });
    };

    return (
        <div className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label className="text-sm font-medium text-slate-200 block mb-1">TCVN Standard Number</label>
                    <input
                        type="text"
                        value={c.tcvn_number || ''}
                        onChange={(e) => update('tcvn_number', e.target.value)}
                        placeholder="e.g. TCVN 12345:2020"
                        className="w-full bg-slate-800 border border-slate-600 rounded-lg p-2.5 text-slate-100 text-sm focus:outline-none focus:ring-2 focus:ring-amber-500/50"
                    />
                </div>
                <div>
                    <label className="text-sm font-medium text-slate-200 block mb-1">MPS Certificate Status</label>
                    <select
                        value={c.mps_cert_status || 'unknown'}
                        onChange={(e) => update('mps_cert_status', e.target.value)}
                        className="w-full bg-slate-800 border border-slate-600 rounded-lg p-2.5 text-slate-100 text-sm focus:outline-none focus:ring-2 focus:ring-amber-500/50"
                    >
                        {STATUS_OPTIONS.map(s => <option key={s} value={s}>{s}</option>)}
                    </select>
                </div>
                <div>
                    <label className="text-sm font-medium text-slate-200 block mb-1">Import License Status</label>
                    <select
                        value={c.import_license_status || 'unknown'}
                        onChange={(e) => update('import_license_status', e.target.value)}
                        className="w-full bg-slate-800 border border-slate-600 rounded-lg p-2.5 text-slate-100 text-sm focus:outline-none focus:ring-2 focus:ring-amber-500/50"
                    >
                        {STATUS_OPTIONS.map(s => <option key={s} value={s}>{s}</option>)}
                    </select>
                </div>
                <div>
                    <label className="text-sm font-medium text-slate-200 block mb-1">Notes</label>
                    <input
                        type="text"
                        value={c.notes || ''}
                        onChange={(e) => update('notes', e.target.value)}
                        placeholder="Any compliance notes..."
                        className="w-full bg-slate-800 border border-slate-600 rounded-lg p-2.5 text-slate-100 text-sm focus:outline-none focus:ring-2 focus:ring-amber-500/50"
                    />
                </div>
            </div>
        </div>
    );
}